export const enum batchConstants  {
  
  //Get Batch
  getBatchRequest = "GET_BATCH_REQUEST",
  getBatchSuccess = "GET_BATCH_SUCCESS",
  getBatchFailure = "GET_BATCH_FAILURE",

  batchCreateRequest = "BATCH_CREATE_REQUEST",
  batchCreateSuccess = "BATCH_CREATE_SUCCESS",
  batchCreateFailure = "BATCH_CREATE_FAILURE",

  batchToggleRequest = "BATCH_TOGGLE_REQUEST",
  batchToggleSuccess = "BATCH_TOGGLE_SUCCESS",
  batchToggleFailure = "BATCH_TOGGLE_FAILURE",

  getBatchParamsRequest = "GET_BATCH_PARAMS_REQUEST",
  getBatchParamsSuccess = "GET_BATCH_PARAMS_SUCCESS",
  getBatchParamsFailure = "GET_BATCH_PARAMS_FAILURE",

  batchDeleteRequest = "BATCH_DELETE_REQUEST",
  batchDeleteSuccess = "BATCH_DELETE_SUCCESS",
  batchDeleteFailure = "BATCH_DELETE_FAILURE",

  getAvailableUsersRequest = "GET_AVAILABLE_USERS_REQUEST",
  getAvailableUsersSuccess = "GET_AVAILABLE_USERS_SUCCESS",
  getAvailableUsersFailure = "GET_AVAILABLE_USERS_FAILURE",

  getAvailableStudentsRequest = "GET_AVAILABLE_STUDENTS_REQUEST",
  getAvailableStudentsSuccess = "GET_AVAILABLE_STUDENTS_SUCCESS",
  getAvailableStudentsFailure = "GET_AVAILABLE_STUDENTS_FAILURE",

  batchViewRequest = "BATCH_VIEW_REQUEST",
  batchViewSuccess = "BATCH_VIEW_SUCCESS",
  batchViewFailure = "BATCH_VIEW_FAILURE",

  attendanceMarkedRequest = "ATTENDANCE_MARKED_REQUEST",
  attendanceMarkedSuccess = "ATTENDANCE_MARKED_SUCCESS",
  attendanceMarkedFailure = "ATTENDANCE_MARKED_FAILURE",

  getBatchHistoryRequest = "GET_BATCH_HISTORY_REQUEST",
  getBatchHistorySuccess = "GET_BATCH_HISTORY_SUCCESS",
  getBatchHistoryFailure = "GET_BATCH_HISTORY_FAILURE",
  getBatchHistoryReset = "GET_BATCH_HISTORY_RESET",

  getOverallStudentAnalyticsRequest = "GET_OVERALL_STUDENT_ANALYTICS_REQUEST",
  getOverallStudentAnalyticsSuccess = "GET_OVERALL_STUDENT_ANALYTICS_SUCCESS",
  getOverallStudentAnalyticsFailure = "GET_OVERALL_STUDENT_ANALYTICS_FAILURE",

  getSessionAnalyticsRequest = "GET_SESSION_ANALYTICS_REQUEST",
  getSessionAnalyticsSuccess = "GET_SESSION_ANALYTICS_SUCCESS",
  getSessionAnalyticsFailure = "GET_SESSION_ANALYTICS_FAILURE",

  getAvailableStudentsForBatchRequest = "GET_AVAILABLE_STUDENTS_FOR_BATCH_REQUEST",
  getAvailableStudentsForBatchSuccess = "GET_AVAILABLE_STUDENTS_FOR_BATCH_SUCCESS",
  getAvailableStudentsForBatchFailure = "GET_AVAILABLE_STUDENTS_FOR_BATCH_FAILURE",

  getCalendarDetailsRequest = "GET_CALENDAR_DETAILS_REQUEST",
  getCalendarDetailsSuccess = "GET_CALENDAR_DETAILS_SUCCESS",
  getCalendarDetailsFailure = "GET_CALENDAR_DETAILS_FAILURE",
};
